<template>
    
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },

        /**
         * The componen't data 
         */
        data(){
            return {
                coporations: [],
                createForm: {
                    errors: [],
                    descripcion_corporacion: '',
                    redirect: '' 
                }
            };
        },

        methods: {
            /**
             * Create a new OAuth client for the user.
             */
            store() {
                this.persistClient(
                    'post', '/corporaciones',
                    this.createForm, '#corporacion-modal-create'
                );
            },

            /**
             * Persist the client to storage using the given form.
             */
            persistClient(method, uri, form, modal) {
                form.errors = [];
                axios[method](uri, form)
                    .then(response => {

                        $('#corporacion').append($('<option>', {
                            value: response.data.CODIGO_CORPORACION,
                            text: response.data.DESCRIPCION_CORPORACION,
                            selected: 'selected',
                        }));

                        form.descripcion_corporacion = '';
                        form.errors = [];

                        $(modal).modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    })
                    .catch(error => {
                        console.log(error);

                        if (typeof error.response.data === 'object') {
                            form.errors = _.flatten(_.toArray(error.response.data));
                        } else {
                            form.errors = ['Something went wrong. Please try again.'];
                        }
                    });
            },
        }  
    }
</script>
